/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';

class Twitter extends React.Component {
  render() {
    return (
      <svg height="512px" width="512px" version="1.1" viewBox="0 0 299.997 299.997" xmlSpace="preserve" width="30px" height="30px">
				<path className="active-path" d="m150 0c-82.839 0-150 67.158-150 150 0 82.837 67.156 150 150 150s150-67.163 150-150c0-82.839-67.161-150-150-150zm3e-3 52.686l88.763 55.35h-177.53l88.763-55.35zm89.869 143.74h-9e-3c0 8.878-7.195 16.072-16.072 16.072h-147.58c-8.878 0-16.072-7.195-16.072-16.072v-84.865c0-0.939 0.096-1.852 0.252-2.749l84.808 52.883c0.104 0.065 0.215 0.109 0.322 0.169 0.112 0.062 0.226 0.122 0.34 0.179 0.599 0.309 1.216 0.558 1.847 0.721 0.065 0.018 0.13 0.026 0.195 0.041 0.692 0.163 1.393 0.265 2.093 0.265h5e-3 0.01c0.7 0 1.401-0.099 2.093-0.265 0.065-0.016 0.13-0.023 0.195-0.041 0.63-0.163 1.245-0.412 1.847-0.721 0.114-0.057 0.228-0.117 0.34-0.179 0.106-0.06 0.218-0.104 0.322-0.169l84.808-52.883c0.156 0.897 0.252 1.808 0.252 2.749v84.865z" fill=" rgba(var(--ey-spotmentor), 1)"/>
			</svg>
    );
  }
}

export default Twitter;



// WEBPACK FOOTER //
// ./src/components/Footer/icons/Envelope.js